import { render, staticRenderFns } from "./children-view.vue?vue&type=template&id=aeeacff4&"
import script from "./children-view.vue?vue&type=script&lang=js&"
export * from "./children-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports